module.exports = __webpack_public_path__ + "static/media/additionNum.e86c24e3.svg";